import React from "react";

import {
  MdmObjectDto,
  useCreateObjectMutation
} from "gql/generated/types";
import { useNavigate, useParams } from "react-router-dom";
import { T } from "services/lang/LanguageService";
import ObjectForm from "../components/ObjectForm";
import { errorToaster, successToaster } from "../utils/utils";

const NewObjectForm = () => {
  const navigate = useNavigate();
  const { projectId } = useParams();
  const [createObjectMutation, { loading }] = useCreateObjectMutation({
    onCompleted: () => {
      successToaster(T("alert.object-updated-successfully"));
      navigate(`/mdm/${projectId}/`);
    },
    onError: errorToaster,
  });
 
  const handleCreate = (object: MdmObjectDto) => {
    createObjectMutation({
      variables: { object: { ...object, projectId } },
    });
  };

  return <ObjectForm object={null} onSubmit={handleCreate} loading={loading} />;
};

export default NewObjectForm;
